import { render } from "./GoogleSignIn.vue?vue&type=template&id=3ee8ee60"
import script from "./GoogleSignIn.vue?vue&type=script&lang=js"
export * from "./GoogleSignIn.vue?vue&type=script&lang=js"

import "./GoogleSignIn.vue?vue&type=style&index=0&id=3ee8ee60&lang=scss"

import exportComponent from "/tmp/build/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__